var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroBgShapeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 326,
    viewBox: "0 0 291 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M475.014 240.543C529.747 185.81 529.747 97.0623 475.014 42.3183C439.285 6.60025 385.78 -7.21573 337.208 6.68874C308.415 14.9297 290.495 32.8716 267.597 51.0127C198.208 106 102.945 158.432 13.0029 121.973C-13.4233 111.254 13.379 163.487 17.5161 171.253C99.5491 325.275 302.287 373.227 443.245 268.053C454.484 259.668 465.103 250.465 475.014 240.543Z",
    stroke: "#ED041D",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M465.921 236.185C518.166 183.941 518.166 99.2417 465.921 46.9976C431.829 12.8946 380.758 -0.279777 334.399 12.9831C306.922 20.8479 289.809 37.9713 267.963 55.2828C201.737 107.77 110.81 157.813 24.9606 123.013C-0.270974 112.792 25.3146 162.636 29.2636 170.058C107.558 317.056 301.059 362.829 435.59 262.445C446.32 254.436 456.453 245.653 465.921 236.196V236.185Z",
    stroke: "#ED041D",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M456.84 231.826C506.595 182.071 506.595 101.409 456.84 51.6653C424.363 19.1994 375.736 6.64447 331.589 19.2769C305.417 26.7656 289.134 43.0704 268.328 59.5633C205.265 109.54 118.675 157.193 36.9182 124.064C12.8924 114.329 37.2612 161.795 41.0221 168.863C115.577 308.848 299.853 352.431 427.958 256.836C438.168 249.215 447.825 240.852 456.84 231.837V231.826Z",
    stroke: "#ED041D",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M447.747 227.468C495.002 180.213 495.002 103.589 447.747 56.3336C416.907 25.4938 370.714 13.5694 328.779 25.5712C303.924 32.6839 288.448 48.1701 268.681 63.8334C208.783 111.31 126.528 156.574 48.8757 125.093C26.0555 115.845 49.1965 160.932 52.7694 167.647C123.597 300.619 298.625 342.022 420.314 251.217C430.015 243.983 439.185 236.03 447.747 227.468Z",
    stroke: "#ED041D",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M438.654 223.11C483.421 178.343 483.421 105.768 438.654 61.0013C409.441 31.7986 365.681 20.4936 325.959 31.865C302.408 38.6015 287.752 53.2692 269.035 68.1139C212.289 113.079 134.382 155.965 60.8223 126.143C39.2079 117.382 61.1321 160.091 64.5169 166.452C131.606 292.411 297.397 331.624 412.671 245.609C421.863 238.751 430.546 231.218 438.654 223.11Z",
    stroke: "#ED041D",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M429.573 218.752C471.839 176.485 471.839 107.947 429.573 65.6807C401.985 38.093 360.659 27.4296 323.16 38.1594C300.926 44.5198 287.088 58.38 269.4 72.384C215.818 114.85 142.247 155.335 72.791 127.183C52.3823 118.909 73.0786 159.24 76.2754 165.246C139.625 284.181 296.192 321.215 405.038 240.001C413.722 233.53 421.918 226.417 429.573 218.763V218.752Z",
    stroke: "#ED041D",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M420.48 214.393C460.258 174.615 460.258 110.126 420.48 70.348C394.519 44.3864 355.637 34.3535 320.339 44.4528C299.422 50.4371 286.391 63.4788 269.755 76.6642C219.336 116.63 150.101 154.726 84.7377 128.234C65.5347 120.446 85.0143 158.399 88.023 164.051C147.634 275.973 294.964 310.828 397.395 234.392C405.558 228.297 413.279 221.605 420.48 214.404V214.393Z",
    stroke: "#ED041D",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M411.387 210.035C448.676 172.746 448.676 112.305 411.387 75.0164C387.052 50.6808 350.604 41.2784 317.53 50.7472C297.917 56.3554 285.705 68.5785 270.119 80.9344C222.864 118.389 157.965 154.107 96.7062 129.274C78.6978 121.973 96.9606 157.547 99.7813 162.846C155.654 267.754 293.747 300.419 389.762 228.773C397.417 223.065 404.651 216.793 411.41 210.035H411.387Z",
    stroke: "#ED041D",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M402.306 205.676C437.095 170.888 437.095 114.484 402.306 79.6844C379.596 56.9748 345.593 48.203 314.72 57.0301C296.424 62.2734 285.03 73.6668 270.473 85.2041C226.371 120.159 165.819 153.476 108.653 130.302C91.8502 123.488 108.885 156.684 111.518 161.629C163.662 259.524 292.519 289.999 382.096 223.154C389.242 217.822 395.99 211.97 402.295 205.665L402.306 205.676Z",
    stroke: "#ED041D",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M393.213 201.318C425.513 169.018 425.513 116.652 393.213 84.3634C372.13 63.28 340.56 55.1386 311.899 63.3353C294.909 68.2024 284.334 78.7773 270.827 89.485C229.888 121.929 173.673 152.868 120.599 131.353C105.002 125.037 120.821 155.844 123.265 160.434C171.671 251.317 291.302 279.612 374.464 217.557C381.09 212.612 387.362 207.181 393.213 201.329V201.318Z",
    stroke: "#ED041D",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBgShapeRed);
export default __webpack_public_path__ + "static/media/hero_bg_shape_red.fbb284f5ef2c277ecc75e892caf5bdab.svg";
export { ForwardRef as ReactComponent };